import { render, staticRenderFns } from "./zxzf.vue?vue&type=template&id=c7c9f278&scoped=true"
import script from "./zxzf.vue?vue&type=script&lang=js"
export * from "./zxzf.vue?vue&type=script&lang=js"
import style0 from "./zxzf.vue?vue&type=style&index=0&id=c7c9f278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c9f278",
  null
  
)

export default component.exports